// eslint-disable-next-line @trello/export-matches-filename
import { Noun, Verb, trackUe } from '@trello/analytics';
import {
  Analytics,
  ActionSubjectType,
  ActionType,
  ActionSubjectIdType,
  SourceType,
} from '@trello/atlassian-analytics';

export interface SnowplowContext {
  organizationId: string | null | undefined;
  totalEmailAddresses?: number;
  totalClaimableEmailAddresses?: number;
}

interface GasContainers {
  enterprise?: { id: string };
}

/**
 * Converts a snowplow event context to a GAS attributes object,
 * which includes containers, instead of id Fields.
 *
 * @param context Snowplow event context
 * @returns {object}
 */
const transformToGas = (context: SnowplowContext) => {
  const attributes = {};
  const containers = {} as GasContainers;
  if (context.organizationId) {
    containers.enterprise = { id: context.organizationId };
  }
  return { attributes, containers };
};

interface AaMigrationAnalyticsParams {
  verb: Verb;
  noun: Noun;
  method: string;
  context: SnowplowContext;
  actionSubject: ActionSubjectType;
  action: ActionType;
  actionSubjectId: ActionSubjectIdType;
  source: SourceType;
}

export const track = ({
  verb,
  noun,
  method,
  context,
  actionSubject,
  actionSubjectId,
  action,
  source,
}: AaMigrationAnalyticsParams) => {
  //Send Snowplow Analytics
  trackUe({
    category: Noun.AA_MIGRATION_WIZARD,
    verb: verb,
    directObj: noun,
    method: method,
    context: JSON.stringify(context),
  });

  const { attributes, containers } = transformToGas(context);

  //Send Atlassian Analytics
  Analytics.sendUIEvent({
    action,
    actionSubject,
    actionSubjectId,
    source,
    attributes,
    containers,
  });
};

export const trackScreenEvent = (
  screen: SourceType,
  context: SnowplowContext,
) => {
  trackUe({
    category: Noun.AA_MIGRATION_WIZARD,
    verb: Verb.VIEWS,
    directObj: screen as Noun,
    context: JSON.stringify(context),
  });

  const { attributes, containers } = transformToGas(context);

  Analytics.sendScreenEvent({
    name: screen,
    attributes,
    containers,
  });
};
